import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize } = redesignTheme;

export const useResultDiagramSectionStyles = makeStyles(() => ({
  diagramSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
  },
  diagramTitle: {
    margin: '3px 0 0',
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    lineHeight: '24px',
    minHeight: 24,
  },
  diagramWrap: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    '& > div': {
      width: '100% !important',
      marginTop: '0 !important',
      marginBottom: '0 !important',
    },
  },
  pieChartWrap: {
    width: '100%',
    '& > div': {
      width: '100% !important',
      maxWidth: '100% !important',
    },
  },
}));
